export const DenverData = [
  {
    title: "For USCIS Purposes",
    detail:
      "There are about 346,700 immigrants in Denver and Tomedes is skilled with translations for immigrant applications to USCIS. Our translators know the process of applying for visas, green cards, and permanent residencies, among others. Tomedes can translate and certify these documents for USCIS purposes.",
    link: "/uscis-translation-services",
  },
  {
    title: "Legal Documents",
    detail:
      "Your legal documents are safe in Tomedes' legal translation services in Denver. From legal documents such as business contracts, loan agreements, non-disclosure agreements, and more, Tomedes legal translators have the expertise needed for the industry. If your documents require notarized or certified legal translations, we can also provide.",
    link: "/legal-translation.php",
  },
  {
    title: "Medical Documents",
    detail:
      "Documents for the medical industry in Denver such as clinical findings, patient records, diagnostic test results, and daily patient progress notes can all undergo translation services into one of 120 languages. Our medical translators have the know-how of almost every medical field out there. Our medical interpreters can also provide consecutive or simultaneous interpretation.",
    link: "/medical-translation.php",
  },
  {
    title: "Technical Documents",
    detail:
      "Your technical documents require specific care and attention, which is how Tomedes operates for all translations. These technical documents have their own specific terminologies and jargon, be it for the highly technological and scientific field of data science or for the engineering industry. Our technical translators know the ins and outs of their industries and their languages.",
    link: "/technical-translation.php",
  },
];

export const LanguagesInDenver = [
  {
    heading: "Chinese",
    detail:
      "One of the most spoken languages in Denver, Chinese is also spoken by 1.3 billion people in the world. Chinese is also a premier business language and Chinese translation services can provide businesses and individuals with what they need for expanding their horizons.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Spanish",
    detail:
      "The most popular language in Denver, Spanish is spoken by 11.6% of the population. One of the major languages in the world, Spanish translation services in Denver can assist you with your university and immigration applications, your documents, and more.",
    link: "/spanish-translation.php",
  },
  {
    heading: "German",
    detail:
      "Another Denver language, German is spoken by a percentage of Denver residents. Access German communities in Denver through German translation services, either German to English or English to German, or any other language pair you can think of.",
    link: "/german-translation.php",
  },
  {
    heading: "Italian",
    detail:
      "A popular language in Denver and in the rest of the world, Italian has applications for both business and individuals. Italian translation services provide an added benefit of extending your business abroad or translating your documents for your applications.",
    link: "/italian-translation.php",
  },
];
